import { revealPage } from '../core/page-reveal/reveal-page'

export const initPageReveal = (ctx) => {
	const runPageReveal = (mode) => requestAnimationFrame(() => revealPage(mode))

	// const onDomReady = () => runPageReveal('direct')
	// if (document.readyState === 'loading') {
	// 	document.addEventListener('DOMContentLoaded', onDomReady, { once: true })
	// } else {
	// 	onDomReady()
	// }

	const swup = ctx.swup

	// When Swup is active, the reveal controller drives the entrance from the `in`
	// transition so it coincides with the mask exit (instead of playing behind the
	// still-visible mask during content:replace). Only the no-Swup fallback runs the
	// reveal directly here.
	if (!swup) {
		window.addEventListener('popstate', () => runPageReveal('history'))
	}

	return { runPageReveal }
}
